export default {
  path: '/alarms/tracking',
  name: 'Alarms',
  component: () => import(/* webpackChunkName: "satellite-tracking" */ '../views/AlarmsView.vue')
}
